export default __webpack_public_path__ + "static/media/regimg-wallets.ba9bda07.png";